import React from 'react';
import CardProfileStore from 'stores/CardProfileStore';
import DepartmentFormStore from 'stores/department/DepartmentFormStore';
import CardProfilesPage from './CardProfilesPage';
import AltContainer from 'alt-container';
import CardProfileActions from 'actions/CardProfileActions';
import DepartmentActions from 'actions/department/DepartmentActions';

export default class CardProfilesPageContainer extends React.PureComponent {
  componentDidMount() {
    CardProfileActions.fetchAll();
  }
  render() {
    return (
      <AltContainer stores={{CardProfileStore, DepartmentFormStore}} actions={{DepartmentActions}}>
        <CardProfilesPage hasDepartmentContext={!!this.props.params.departmentId} />
      </AltContainer>
    );
  }
}
